import React from 'react';

import type { FacebookGroupPostComponentsProps } from './types';

export function Body(_props: FacebookGroupPostComponentsProps): React.JSX.Element {
	return <div>Facebook Group Post Body</div>;
}
